// Shapes section that lives between Equipment and the brush controls.
// Selecting a shape switches the canvas into stamp mode (each click drops
// the whole pattern); selecting a material from the Materials list above
// flips back to paintbrush mode.

import type { ShapeDef, ShapeGroup } from "../sim/shapes";

import { ShapeIcon } from "./ShapeIcons";

export interface ShapesPanelProps {
  groups: ShapeGroup[];
  selectedShapeId: string | null;
  onSelect: (shape: ShapeDef | null) => void;
}

export function ShapesPanel({
  groups,
  selectedShapeId,
  onSelect,
}: ShapesPanelProps) {
  if (groups.length === 0) return null;
  return (
    <>
      <h2>Shapes</h2>
      {groups.map((group) => (
        <details key={group.category} open>
          <summary className="category-summary">
            {group.category} ({group.members.length})
          </summary>
          <div className="shape-grid">
            {group.members.map((shape) => {
              const active = shape.id === selectedShapeId;
              return (
                <button
                  key={shape.id}
                  type="button"
                  className={"shape-button" + (active ? " active" : "")}
                  onClick={() => onSelect(active ? null : shape)}
                  title={`${shape.id} - ${shape.cells.length} cells`}
                >
                  <ShapeIcon name={shape.icon} />
                  <span className="shape-name">{shape.name}</span>
                </button>
              );
            })}
          </div>
        </details>
      ))}
    </>
  );
}
